module.exports = __webpack_public_path__ + "static/media/nav-side-bar-drop-down-arrow.22de7163.svg";